module.exports = __webpack_public_path__ + "img/a-turkey.e1710058.svg";